import { Injectable, inject } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SentenceCasePipe } from '../pipes/sentence-case.pipe';
import { TitleCasePipe } from '@angular/common';
import { Locales } from '../constants/locales.config';
import { PrimeNGConfig } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class CustomTranslateService {
  sentenceCasePipe = inject(SentenceCasePipe);
  titleCasePipe = inject(TitleCasePipe);
  private translateService = inject(TranslateService);

  private languageSubject = new BehaviorSubject<any>({});
  language$: Observable<string> = this.languageSubject.asObservable();

  get locale(): string {
    return (
      localStorage.getItem('lang') ||
      this.translateService.getBrowserLang() ||
      'en'
    );
  }

  constructor(private config: PrimeNGConfig) {
    this.initialization();
    this.translatePrimeng();
  }

  private initialization() {
    const lang = localStorage.getItem('lang');
    this.translateService.setDefaultLang(
      lang && Locales.includes(lang) ? lang : 'en'
    );
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.languageSubject.next(event.lang);
    });
  }

  translatePrimeng() {
    this.translateService.get('primeng').subscribe((res) => {
      this.config.setTranslation(res);
    });
    this.translateService.get('common.no-results-found').subscribe((translatedText) => {
      this.config.setTranslation({
        emptyFilterMessage: translatedText,
        emptyMessage: translatedText
      });
    });
  }

  setLanguage(lang: string) {
    localStorage.setItem('lang', lang);
    try {
      this.translateService.use(lang);
      this.translatePrimeng();
    } catch (error) {
      console.warn('Cannot translate this language, apply English as default');
      this.translateService.use(this.translateService.getDefaultLang());
    }
  }

  transform(key: string): string {
    return this.translateService.instant(key) as string;
  }

  sentenceCase(value: string): string {
    value = this.transform(value);
    return this.sentenceCasePipe.transform(value);
  }

  titleCase(value: string): string {
    value = this.transform(value);
    return this.titleCasePipe.transform(value);
  }

  transformKeyValue(key: string, value:{name:string}): string {
    const  translatedValue  = this.translateService.instant(key, value ) as string;
    return this.sentenceCasePipe.transform(translatedValue);
  }

  transformKeyValueSentence(key: string, value:{name:string}): string {
    const  translatedValue  = this.translateService.instant(key, value ) as string;
    return this.sentenceCasePipe.transform(translatedValue);
  }
}
